<div class="container" [ngClass]="version">
    @if (data?.headerData) {
        <finder-component-header
            [data]="data.headerData"
        ></finder-component-header>
    }
        <div class="scroll-wrapper">
            <table>
                <thead>
                    <tr class="columns">
                        @for (column of data?.columns; track column; let columnIndex = $index) {
                            <th class="column-header color-{{columnIndex - 1}} column-{{columnIndex}}"
                                [id]="column.value" [ngClass]="{'icon': column.icon}">
                                @if (column.picture || column.icon) {
                                    <div class="image">
                                        <!-- This is for column navigation enabled with the v2 table -->
                                        @if (columnNavigation) {
                                            <finder-button class="previous" anchor="true" (click)="selectColumn(columnIndex - 1)">
                                                <finder-font-icon size="s" name="previous"></finder-font-icon>
                                            </finder-button>
                                        }
                                        <!-- If the column image is a webfont -->
                                        @if (column.icon) {
                                            <finder-font-icon
                                                id="icon-font-{{columnIndex}}"
                                                class="icon-font"
                                                size="xl"
                                                [hexValue]="column.icon">
                                            </finder-font-icon>
                                        }
                                        <!-- If the column image is a image -->
                                        @if (column.picture) {
                                            <finder-picture
                                                [picture]="column.picture"
                                            ></finder-picture>
                                        }
                                        <!-- This is for column navigation enabled with v2 table -->
                                        @if (columnNavigation) {
                                            <finder-button class="next" anchor="true" (click)="selectColumn(columnIndex + 1)">
                                                <finder-font-icon size="s" name="next"></finder-font-icon>
                                            </finder-button>
                                        }
                                    </div>
                                }
                                @if (column.icon) {
                                    <finder-font-icon size="inherit" [hexValue]="column.icon"></finder-font-icon>
                                }
                                <span class="content" [innerHTML]="column.value | safeHtml"></span>
                            </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    <tr class="rows" [ngClass]="{'odd': isOdd, 'even': isEven, 'header': row.header}" *ngFor="let row of data?.rows; odd as isOdd; even as isEven; index as rowIndex">
                        @if (row.header) {
                            <td class="header">
                                <span class="desktop">
                                    <span [innerHTML]="row.header.title | safeHtml"></span> | <span>{{row.header.subtitle}}</span>
                                </span>
                                <span class="mobile">
                                    <span [innerHTML]="row.header.title | safeHtml"></span>
                                    <p>{{row.header.subtitle}}</p>
                                </span>
                            </td>
                        }
                        @if (row.name) {
                            <td class="row" [headers]="data?.columns?.[0]?.value">
                                <span [innerHTML]="row.name | safeHtml"></span>
                            </td>
                        }
                        <div class="values" *ngIf="row.values && isMobile && version === 'v1'; else values">
                            <ng-container *ngTemplateOutlet="values"></ng-container>
                        </div>
                        <ng-template #values>
                            @for (value of row?.values; track $index; let valueIndex = $index) {
                                <td [ngClass]="{'no-background': value !== '✓'}"
                                    class="value color-{{valueIndex}}"
                                    [headers]="data?.columns?.[valueIndex + 1]?.value">
                                    <div>
                                        <ng-container [ngSwitch]="value">
                                            <!-- For Dashes and Checkmarks we use SVG icons -->
                                            <finder-font-icon *ngSwitchCase="'✓'" size="s" name="checkmark"></finder-font-icon>
                                            <finder-font-icon *ngSwitchCase="''" class="dash" size="s" name="na-dash"></finder-font-icon>
                                            <!-- If the content is an asterisk we add a css class to make it look nicer (since there isn't an SVG icon for it) -->
                                            <!-- If not we display the provided content as normal text -->
                                            <span *ngSwitchDefault [ngClass]="{'asterisk': value === '*'}" [innerHTML]="value | safeHtml"></span>
                                            @if (value.includes('<a')) {
                                                <finder-anchor
                                                    [href]="extractHref(value)">
                                                    <finder-font-icon
                                                        size="xs"
                                                        class="away-arrow"
                                                        name="return-arrow">
                                                    </finder-font-icon>
                                                </finder-anchor>
                                            }
                                        </ng-container>
                                        <!-- Check for a read more value. You can't set and use a template variable on the same line -->
                                        <div #readMore class="read-more-container" [attr.data-position]="rowIndex + '_' + valueIndex" [attr.data-isOpen]="false">
                                            @if (checkForReadMore(readMore)) {
                                                <div class="read-more-btn">
                                                    <finder-button anchor="true" (click)="toggleReadMore(readMore)">
                                                        @if (isReadMoreOpen(readMore)) {
                                                            {{data.labels.showLess}}
                                                        } @else {
                                                            {{data.labels.readMore}}
                                                        }
                                                        @if (isReadMoreOpen(readMore)) {
                                                            <finder-font-icon name="norgie-up" size="xs"></finder-font-icon>
                                                        } @else {
                                                            <finder-font-icon name="norgie-opened" size="xs"></finder-font-icon>
                                                        }
                                                    </finder-button>
                                                </div>
                                                <div class="read-more-copy" [ngClass]="{'hidden': !isReadMoreOpen(readMore)}">
                                                    {{readMore.dataset.content}}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </td>
                            }
                        </ng-template>
                    </tr>
                </tbody>
                @if (data?.footer?.length) {
                    <tfoot>
                        <tr>
                            @if (!isMobile) {
                                <td class="empty-slot"></td>
                            }
                            @for (content of data.footer; track content) {
                                <td>
                                    <div [innerHTML]="content | safeHtml"></div>
                                </td>
                            }
                        </tr>
                    </tfoot>
                }
            </table>
        </div>
</div>
